export enum CardTypes {
    AuditSummary = 1,
    RiskRegister = 2
}
